import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { ApiManager } from '../../../core/api-manager';
import { toast } from 'react-toastify';
import ModalListPicker from '../../../components/Modals/ModalListPicker';


export default function IC_customer({ data, entity, setDataKeyValue }) {

    const [showModalCustomer, setShowModalCustomer] = useState(false);
    const [showModalFormularioOrder, setShowModalFormularioOrder] = useState(false);
    const [showModalFormularioInvoice, setShowModalFormularioInvoice] = useState(false);
    const [showModalFormularioCommercial, setShowModalFormularioCommercial] = useState(false);

    // Ricerca P.IVA duplicata
    async function searchIva(iva) {
        var constraints = [
            { fieldName: "vatNumber", type: "value", value: iva }
        ]
        var sorting = { 'field': 'id', 'order': 'desc' }
        var response = await DataManager.searchItems('customer', 1, 100, sorting, '', [], constraints);
        if (response.success === 1 && response.body.length > 0) {
            setShowModalCustomer(true);
        }
    }

    // Verifica VIES
    async function checkVies() {
        var body = {
            state: data.stateVatNumber,
            vatNumber: data.vatNumber
        }
        var res = await ApiManager.sendAuthenticatedRequest('/custom/check_vat', body);
        if (res.valid && res.valid === true) {
            toast.success("Partita IVA validata dal VIES! Ragione sociale: " + res.name, { theme: 'colored' })
        } else {
            toast.error("Partita IVA non validata dal VIES!", { theme: 'colored' })
        }
    }

    // Copia indirizzo in sedi
    async function copyAddress() {
        if (data && data.offices.length === 0) {
            var constraints = [
                { fieldName: "defaultType", type: "value", value: 1 }
            ]
            var sorting = { 'field': 'id', 'order': 'desc' }
            var res = await DataManager.searchItems('type_office', 1, 100, sorting, '', [], constraints);
            var temp = []
            var body = {
                address: data.address,
                cap: data.cap,
                city: data.city,
                email: "",
                idCountry: data.idCountry,
                internalNotes: "",
                isDeliveryDefault: true,
                name: "Sede 1",
                phone: "39"
            }
            temp.push(body);
            if (data.offices !== temp) {
                setDataKeyValue('offices', temp)
            }
        } else {
            toast.warning("Funzione disponibile solo se non ci sono indirizzi di consegna associati.", { theme: 'colored' })
        }
    }

    // Note formulario
    var searchObjOrder = {
        'query': '', 'fields': [],
        'constraints': [{ fieldName: "type", type: "value", value: '0_ORDER' }]
    }
    var searchObjInvoice = {
        'query': '', 'fields': [],
        'constraints': [{ fieldName: "type", type: "value", value: '10_INVOICE' }]
    }
    var searchObjCommercial = {
        'query': '', 'fields': [],
        'constraints': [{ fieldName: "type", type: "value", value: '20_COMMERCIAL' }]
    }

    function selectRowOrder(e) {
        var testo = data.notesOrder + e.description + ' ';
        if (data.notesOrder !== testo) {
            setDataKeyValue('notesOrder', testo);
            toast.success('Nota aggiunta con successo!')
        }
    }
    function selectRowInvoice(e) {
        var testo = data.notesInvoice + e.description + ' ';
        if (data.notesInvoice !== testo) {
            setDataKeyValue('notesInvoice', testo)
            toast.success('Nota aggiunta con successo!')
        }
    }
    function selectRowCommercial(e) {
        var testo = data.notesInternal + e.description + ' ';
        if (data.notesInternal !== testo) {
            setDataKeyValue('notesInternal', testo)
            toast.success('Nota aggiunta con successo!')
        }
    }

    // P.IVA: ricerca duplicati e autocompile taxCode
    useEffect(() => {
        if (data.vatNumber !== "" && window.location.pathname === "/entity/customer/add") {
            searchIva(data.vatNumber);
        }
        if (data.category.value !== 0 && window.location.pathname === "/entity/customer/add") {
            setDataKeyValue('taxCode', data.vatNumber)
        }
    }, [data.vatNumber])

    // VIES check con debounce
    useEffect(() => {
        if (window.location.pathname === "/entity/customer/add" && data.vatNumber !== "") {
            const timeOutId = setTimeout(() => checkVies(), 1000);
            return () => clearTimeout(timeOutId);
        }
    }, [data.vatNumber]);

    // Autocompile da country (on change)
    useEffect(() => {
        if (data.certificatoOrigine !== data.idCountry.certificatoOrigine) {
            setDataKeyValue('certificatoOrigine', { value: data.idCountry.certificatoOrigine });
        }
        if (data.codiciDoganaliInFatt !== data.idCountry.codiciDoganaliInFatt) {
            setDataKeyValue('codiciDoganaliInFatt', { value: data.idCountry.codiciDoganaliInFatt });
        }
        if (data.idCountryStats !== data.idCountry) {
            setDataKeyValue('idCountryStats', data.idCountry);
        }
        if (data.idCountryGroup !== data.idCountry.idCountryGroup) {
            setDataKeyValue('idCountryGroup', data.idCountry.idCountryGroup);
        }
        if (data.idCountryGroup2 !== data.idCountry.idCountryGroup2) {
            setDataKeyValue('idCountryGroup2', data.idCountry.idCountryGroup2);
        }
        if (window.location.pathname === "/entity/customer/add") {
            if (data.countryCode !== "" && data.idCountry && data.countryCode !== "") {
                if (data.idCountry.codiceISO !== data.countryCode) {
                    toast.warning("Attenzione! Nazioni diverse.")
                }
            }
        }
        if (data.idVatCondition !== data.idCountry.idVatCondition) {
            setDataKeyValue('idVatCondition', data.idCountry.idVatCondition);
        }
        if (data.idIncoterms !== data.idCountry.idIncoterms) {
            setDataKeyValue('idIncoterms', data.idCountry.idIncoterms);
        }
    }, [data.idCountry]);

    // Logica visibilità campi e autocompile da data
    useEffect(() => {
        var p_iva = document.getElementById("customer_field_vatNumber");
        var state_p_iva = document.getElementById("customer_field_stateVatNumber");
        var namePrivate = document.getElementById("customer_field_namePrivate");
        var surnamePrivate = document.getElementById("customer_field_surnamePrivate");
        var sdi = document.getElementById("customer_field_sdi");
        if (data.category && (data.category.value === "0" || data.category.value === 0)) {
            p_iva.style.display = 'none';
            state_p_iva.style.display = 'none';
            namePrivate.style.display = 'block';
            surnamePrivate.style.display = 'block';
            sdi.style.display = 'none';
        } else {
            p_iva.style.display = 'block';
            state_p_iva.style.display = 'block';
            namePrivate.style.display = 'none';
            sdi.style.display = 'block';
            surnamePrivate.style.display = 'none';
        }
        if (data.category && (data.category.value === "2" || data.category.value === 2)) {
            namePrivate.style.display = 'block';
            surnamePrivate.style.display = 'block';
        }
        if (data.idCountry && data.idCountry.codiceISO) {
            if (data.stateVatNumber !== data.idCountry.codiceISO) {
                setDataKeyValue('stateVatNumber', data.idCountry.codiceISO);
            }
        }
        if (data.idCountry) {
            if (data.idCountryStats === "" && data.idCountryStats !== data.idCountry) {
                setDataKeyValue('idCountryStats', data.idCountry);
            }
            if (data.idCountryGroup === "" && data.idCountryGroup !== data.idCountry.idCountryGroup) {
                setDataKeyValue('idCountryGroup', data.idCountry.idCountryGroup);
            }
            if (data.idCountryGroup2 === "" && data.idCountryGroup2 !== data.idCountry.idCountryGroup2) {
                setDataKeyValue('idCountryGroup2', data.idCountry.idCountryGroup2);
            }
            if (data.italiaEstero === "" && data.italiaEstero !== data.idCountry.italiaEstero) {
                setDataKeyValue('italiaEstero', data.idCountry.italiaEstero);
            }
            if (data.certificatoOrigine === "" && data.certificatoOrigine !== data.idCountry.certificatoOrigine) {
                setDataKeyValue('certificatoOrigine', { value: data.idCountry.certificatoOrigine });
            }
            if (data.codiciDoganaliInFatt === "" && data.codiciDoganaliInFatt !== data.idCountry.codiciDoganaliInFatt) {
                setDataKeyValue('codiciDoganaliInFatt', { value: data.idCountry.codiciDoganaliInFatt });
            }
            if (data.idIncoterms === "" && data.idIncoterms !== data.idCountry.idIncoterms) {
                setDataKeyValue('idIncoterms', data.idCountry.idIncoterms);
            }
            if (data.idVatCondition === "" && data.idVatCondition !== data.idCountry.idVatCondition) {
                setDataKeyValue('idVatCondition', data.idCountry.idVatCondition);
            }
        }
    }, [data]);

    // Bottoni note e copia indirizzo (DOM append, solo al mount)
    useEffect(() => {
        const elementIDOrder = document.querySelector('#customer_field_notesOrder .field__text');
        const elementIDInvoice = document.querySelector('#customer_field_notesInvoice .field__text');
        const elementIDCommercial = document.querySelector('#customer_field_notesInternal .field__text');
        const elementOffices = document.querySelector('#customer_field_offices');

        if (elementIDOrder && !elementIDOrder.querySelector('#btn_notesOrder')) {
            elementIDOrder.appendChild(genButtonOrder());
        }
        if (elementIDInvoice && !elementIDInvoice.querySelector('#btn_notesInvoice')) {
            elementIDInvoice.appendChild(genButtonInvoice());
        }
        if (elementIDCommercial && !elementIDCommercial.querySelector('#btn_notesInternal')) {
            elementIDCommercial.appendChild(genButtonCommercial());
        }
        const copyBtn = document.getElementById('copy_offices');
        if (elementOffices && copyBtn && !elementOffices.contains(copyBtn)) {
            elementOffices.appendChild(copyBtn);
        }

        function genButtonOrder() {
            let a = document.createElement('button');
            a.classList.add("btn", "btn-primary", "mt-2", "btn-sm");
            a.id = 'btn_notesOrder';
            a.addEventListener('click', (event) => { event.preventDefault(); setShowModalFormularioOrder(true); })
            a.textContent = "Aggiungi note ordine";
            return a;
        }
        function genButtonInvoice() {
            let a = document.createElement('button');
            a.classList.add("btn", "btn-primary", "mt-2", "btn-sm");
            a.id = 'btn_notesInvoice';
            a.addEventListener('click', (event) => { event.preventDefault(); setShowModalFormularioInvoice(true); })
            a.textContent = "Aggiungi note fattura";
            return a;
        }
        function genButtonCommercial() {
            let a = document.createElement('button');
            a.classList.add("btn", "btn-primary", "mt-2", "btn-sm");
            a.id = 'btn_notesInternal';
            a.addEventListener('click', (event) => { event.preventDefault(); setShowModalFormularioCommercial(true); })
            a.textContent = "Aggiungi note interne";
            return a;
        }
    }, []);

    return (
        <>
            <Button size='sm' className='my-3' variant='primary' id='copy_offices' onClick={() => { copyAddress() }}>Copia indirizzo</Button>
            {showModalCustomer ? <>
                <Modal show={showModalCustomer} onHide={() => setShowModalCustomer(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Partita IVA già esistente</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>È già presente in anagrafica un cliente con la stessa Partita IVA. In fase di caricamento ordine dovrai prestare attenzione a selezionare quello corretto.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={() => { setShowModalCustomer(false) }}>Ho capito</Button>
                    </Modal.Footer>
                </Modal>
            </> : null}

            {showModalFormularioOrder ? <ModalListPicker entity={'formulario'} closeModal={() => setShowModalFormularioOrder(false)} modalStatus={showModalFormularioOrder} selectRow={selectRowOrder} defaultSearchObj={searchObjOrder} /> : null}
            {showModalFormularioInvoice ? <ModalListPicker entity={'formulario'} closeModal={() => setShowModalFormularioInvoice(false)} modalStatus={showModalFormularioInvoice} selectRow={selectRowInvoice} defaultSearchObj={searchObjInvoice} /> : null}
            {showModalFormularioCommercial ? <ModalListPicker entity={'formulario'} closeModal={() => setShowModalFormularioCommercial(false)} modalStatus={showModalFormularioCommercial} selectRow={selectRowCommercial} defaultSearchObj={searchObjCommercial} /> : null}
        </>
    )
};
